import React from 'react'
import './home.scss'
import Typed from 'typed.js';

import Lottie from 'react-lottie';
import animationData from './developer_lottie.json';
export const Home = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  const typed = React.useRef(null);
  const el = React.useRef(null);
  React.useEffect(() => {
    const options = {
      strings: ['MERN stack developer'],
      typeSpeed: 50,
      backSpeed: 40,
      backDelay: 1000,
      // smartBackspace: false, // this is a default
      loop: true,
      fadeout: true
    };

    // elRef refers to the <span> rendered below
    typed.current = new Typed(el.current, options);

    return () => {
      // Make sure to destroy Typed instance during cleanup
      // to prevent memory leaks
      typed.current.destroy();
    }
  }, [])

  return (
    <section class="home"
      id="home" >
      <div class="max-width">
        <div class="home-content">
          <div class="text-1">Hello, my name is</div>
          <div class="text-2">Rathish Kumar</div>
          <div class="text-3">And I'm a <span ref={el}></span></div>
          <a href="#contact">Hire me</a>
        </div>
        <div className="lottieContainer">
          <Lottie
            options={defaultOptions}
            height={400}
            width={400}
          />
        </div>
      </div>

      {/* <img src="/images/home_background.jpg" /> */}
      {/* <BackgroundAnimation /> */}

    </section >


  )
}
